import React from "react";
import { Bars } from "react-loader-spinner";

const Loader = () => {
  return (
    <div>
      <Bars color="#00BFFF" height={80} width={80} />
    </div>
  );
};

export default Loader;
